import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants} from '../constants/app.constants';
import { DashboardResponse } from '../components/model/dashboardresponse';
import { Page } from '../components/model/pagination/page';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private httpClient: HttpClient) { }



  getDashBoardSummary(upn:string, roleId:number): Observable<DashboardResponse[]> {
    
  return this.httpClient.get<DashboardResponse[]>(AppConstants.GET_DASHBOARD_SUMMARY+"?upn="+upn+"&roleId="+roleId);
  
  } 

  getDashPageBoardSummary(sort: string, order: string, pageNumber: number,pageSize:number): Observable<Page<DashboardResponse>> {
    
    return this.httpClient.get<Page<DashboardResponse>>(AppConstants.GET_DASHBOARD_PAGE_SUMMARY+"?pageNo="+pageNumber+"&pageSize="+pageSize);
    
    } 
}
